export const L10N = {
  BOOKING_CODE_LABEL: { id: 'core.label.booking_code' },
  BOOKING_QUERY: { id: 'core.action.booking_query' },
  CTA: { id: 'core.action.booking_query_cta' },
  DESCRIPTION: { id: 'core.label.form_description' },
  LABEL_RESERVATION_CODE: { id: 'common.label.reservation_code' },
  LABEL_RESERVATION_CODE_DESCRIPTION: { id: 'common.label.reservation_code_description' },
  NOTIFICATION_ERROR_AUTHENTICATION: { id: 'core.notification.authentication_error' },
  NOTIFICATION_ERROR_NETWORK: { id: 'common.notification.network_error' },
  PIN_CODE_LABEL: { id: 'core.label.pincode' },
  TITLE: { id: 'core.label.booking_query_title' },
};
